const segs = [
    {
        "stops": [],
        "passengers": [
            {
                "passenger_id": "pas_0000Ab9IpjVYYbrGG5AQjq",
                "fare_basis_code": "VLR5R1SO",
                "cabin_class_marketing_name": "Economy",
                "cabin_class": "economy",
                "cabin": {
                    "name": "economy",
                    "marketing_name": "Economy",
                    "amenities": {
                        "wifi": {
                            "cost": "paid",
                            "available": true
                        },
                        "seat": {
                            "pitch": "31",
                            "legroom": "standard"
                        },
                        "power": {
                            "available": true
                        }
                    }
                },
                "baggages": [
                    {
                        "type": "checked",
                        "quantity": 2
                    }
                ]
            }
        ],
        "origin_terminal": null,
        "origin": {
            "type": "airport",
            "time_zone": "America/New_York",
            "name": "John F. Kennedy International Airport",
            "longitude": -73.778519,
            "latitude": 40.640556,
            "id": "arp_jfk_us",
            "icao_code": "KJFK",
            "iata_country_code": "US",
            "iata_code": "JFK",
            "iata_city_code": "NYC",
            "city_name": "New York",
            "city": {
                "type": "city",
                "time_zone": null,
                "name": "London",
                "longitude": null,
                "latitude": null,
                "id": "cit_nyc_us",
                "icao_code": null,
                "iata_country_code": "US",
                "iata_code": "NYC",
                "iata_city_code": "NYC",
                "city_name": null
            },
            "airports": null
        },
        "operating_carrier_flight_number": "702",
        "operating_carrier": {
            "name": "Qatar Airways",
            "logo_symbol_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/QR.svg",
            "logo_lockup_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/QR.svg",
            "id": "arl_00009VME7DD6Xm0axa2BU9",
            "iata_code": "QR",
            "conditions_of_carriage_url": "https://www.qatarairways.com/en-gb/legal/conditions-of-carriage.html"
        },
        "marketing_carrier_flight_number": "702",
        "marketing_carrier": {
            "name": "Qatar Airways",
            "logo_symbol_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/QR.svg",
            "logo_lockup_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/QR.svg",
            "id": "arl_00009VME7DD6Xm0axa2BU9",
            "iata_code": "QR",
            "conditions_of_carriage_url": "https://www.qatarairways.com/en-gb/legal/conditions-of-carriage.html"
        },
        "id": "seg_0000Ab9IpwldG9RRNhmx6b",
        "duration": "PT12H40M",
        "distance": null,
        "destination_terminal": null,
        "destination": {
            "type": "airport",
            "time_zone": "Asia/Qatar",
            "name": "Hamad International Airport",
            "longitude": 51.615118,
            "latitude": 25.260642,
            "id": "arp_doh_qa",
            "icao_code": "OTHH",
            "iata_country_code": "QA",
            "iata_code": "DOH",
            "iata_city_code": "DOH",
            "city_name": "Doha",
            "city": null,
            "airports": null
        },
        "departing_at": "2023-10-26T20:05:00",
        "arriving_at": "2023-10-27T15:45:00",
        "aircraft": {
            "name": "Boeing 777-300ER",
            "id": "arc_00009VMF8AhXSSRnQDI6HH",
            "iata_code": "77W"
        }
    },
    {
        "stops": [],
        "passengers": [
            {
                "passenger_id": "pas_0000Ab9IpjVYYbrGG5AQjq",
                "fare_basis_code": "VLR5R1SO",
                "cabin_class_marketing_name": "Economy",
                "cabin_class": "economy",
                "cabin": {
                    "name": "economy",
                    "marketing_name": "Economy",
                    "amenities": {
                        "wifi": {
                            "cost": "paid",
                            "available": true
                        },
                        "seat": {
                            "pitch": "31",
                            "legroom": "standard"
                        },
                        "power": {
                            "available": true
                        }
                    }
                },
                "baggages": [
                    {
                        "type": "checked",
                        "quantity": 2
                    }
                ]
            }
        ],
        "origin_terminal": null,
        "origin": {
            "type": "airport",
            "time_zone": "Asia/Qatar",
            "name": "Hamad International Airport",
            "longitude": 51.615118,
            "latitude": 25.260642,
            "id": "arp_doh_qa",
            "icao_code": "OTHH",
            "iata_country_code": "QA",
            "iata_code": "DOH",
            "iata_city_code": "DOH",
            "city_name": "Doha",
            "city": null,
            "airports": null
        },
        "operating_carrier_flight_number": "1423",
        "operating_carrier": {
            "name": "Qatar Airways",
            "logo_symbol_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/QR.svg",
            "logo_lockup_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/QR.svg",
            "id": "arl_00009VME7DD6Xm0axa2BU9",
            "iata_code": "QR",
            "conditions_of_carriage_url": "https://www.qatarairways.com/en-gb/legal/conditions-of-carriage.html"
        },
        "marketing_carrier_flight_number": "1423",
        "marketing_carrier": {
            "name": "Qatar Airways",
            "logo_symbol_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/QR.svg",
            "logo_lockup_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/QR.svg",
            "id": "arl_00009VME7DD6Xm0axa2BU9",
            "iata_code": "QR",
            "conditions_of_carriage_url": "https://www.qatarairways.com/en-gb/legal/conditions-of-carriage.html"
        },
        "id": "seg_0000Ab9IpwldG9RRNhmx6c",
        "duration": "PT9H30M",
        "distance": null,
        "destination_terminal": null,
        "destination": {
            "type": "airport",
            "time_zone": "Africa/Accra",
            "name": "Kotoka International Airport",
            "longitude": -0.167454,
            "latitude": 5.605642,
            "id": "arp_acc_gh",
            "icao_code": "DGAA",
            "iata_country_code": "GH",
            "iata_code": "ACC",
            "iata_city_code": "ACC",
            "city_name": "Lagos",
            "city": null,
            "airports": null
        },
        "departing_at": "2023-10-28T02:15:00",
        "arriving_at": "2023-10-28T08:45:00",
        "aircraft": {
            "name": "Boeing 787-8",
            "id": "arc_00009Y7sVj19iGeh2cDz2O",
            "iata_code": "788"
        }
    },
    {
        "stops": [],
        "passengers": [
            {
                "passenger_id": "pas_0000Ab9IpjVYYbrGG5AQjq",
                "fare_basis_code": "VLR5R1SO",
                "cabin_class_marketing_name": "Economy",
                "cabin_class": "economy",
                "cabin": {
                    "name": "economy",
                    "marketing_name": "Economy",
                    "amenities": {
                        "wifi": {
                            "cost": "paid",
                            "available": true
                        },
                        "seat": {
                            "pitch": "31",
                            "legroom": "standard"
                        },
                        "power": {
                            "available": true
                        }
                    }
                },
                "baggages": [
                    {
                        "type": "checked",
                        "quantity": 2
                    }
                ]
            }
        ],
        "origin_terminal": null,
        "origin": {
            "type": "airport",
            "time_zone": "America/New_York",
            "name": "John F. Kennedy International Airport",
            "longitude": -73.778519,
            "latitude": 40.640556,
            "id": "arp_jfk_us",
            "icao_code": "KJFK",
            "iata_country_code": "US",
            "iata_code": "JFK",
            "iata_city_code": "NYC",
            "city_name": "Lagos",
            "city": {
                "type": "city",
                "time_zone": null,
                "name": "New York",
                "longitude": null,
                "latitude": null,
                "id": "cit_nyc_us",
                "icao_code": null,
                "iata_country_code": "US",
                "iata_code": "NYC",
                "iata_city_code": "NYC",
                "city_name": null
            },
            "airports": null
        },
        "operating_carrier_flight_number": "702",
        "operating_carrier": {
            "name": "Qatar Airways",
            "logo_symbol_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/QR.svg",
            "logo_lockup_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/QR.svg",
            "id": "arl_00009VME7DD6Xm0axa2BU9",
            "iata_code": "QR",
            "conditions_of_carriage_url": "https://www.qatarairways.com/en-gb/legal/conditions-of-carriage.html"
        },
        "marketing_carrier_flight_number": "702",
        "marketing_carrier": {
            "name": "Qatar Airways",
            "logo_symbol_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/QR.svg",
            "logo_lockup_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/QR.svg",
            "id": "arl_00009VME7DD6Xm0axa2BU9",
            "iata_code": "QR",
            "conditions_of_carriage_url": "https://www.qatarairways.com/en-gb/legal/conditions-of-carriage.html"
        },
        "id": "seg_0000Ab9IpwldG9RRNhmx6b",
        "duration": "PT12H40M",
        "distance": null,
        "destination_terminal": null,
        "destination": {
            "type": "airport",
            "time_zone": "Asia/Qatar",
            "name": "Hamad International Airport",
            "longitude": 51.615118,
            "latitude": 25.260642,
            "id": "arp_doh_qa",
            "icao_code": "OTHH",
            "iata_country_code": "QA",
            "iata_code": "DOH",
            "iata_city_code": "DOH",
            "city_name": "Dubai",
            "city": null,
            "airports": null
        },
        "departing_at": "2023-10-26T20:05:00",
        "arriving_at": "2023-10-27T15:45:00",
        "aircraft": {
            "name": "Boeing 777-300ER",
            "id": "arc_00009VMF8AhXSSRnQDI6HH",
            "iata_code": "77W"
        }
    },
    {
        "stops": [],
        "passengers": [
            {
                "passenger_id": "pas_0000Ab9IpjVYYbrGG5AQjq",
                "fare_basis_code": "VLR5R1SO",
                "cabin_class_marketing_name": "Economy",
                "cabin_class": "economy",
                "cabin": {
                    "name": "economy",
                    "marketing_name": "Economy",
                    "amenities": {
                        "wifi": {
                            "cost": "paid",
                            "available": true
                        },
                        "seat": {
                            "pitch": "31",
                            "legroom": "standard"
                        },
                        "power": {
                            "available": true
                        }
                    }
                },
                "baggages": [
                    {
                        "type": "checked",
                        "quantity": 2
                    }
                ]
            }
        ],
        "origin_terminal": null,
        "origin": {
            "type": "airport",
            "time_zone": "America/New_York",
            "name": "John F. Kennedy International Airport",
            "longitude": -73.778519,
            "latitude": 40.640556,
            "id": "arp_jfk_us",
            "icao_code": "KJFK",
            "iata_country_code": "US",
            "iata_code": "JFK",
            "iata_city_code": "NYC",
            "city_name": "Dubai",
            "city": {
                "type": "city",
                "time_zone": null,
                "name": "New York",
                "longitude": null,
                "latitude": null,
                "id": "cit_nyc_us",
                "icao_code": null,
                "iata_country_code": "US",
                "iata_code": "NYC",
                "iata_city_code": "NYC",
                "city_name": null
            },
            "airports": null
        },
        "operating_carrier_flight_number": "702",
        "operating_carrier": {
            "name": "Qatar Airways",
            "logo_symbol_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/QR.svg",
            "logo_lockup_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/QR.svg",
            "id": "arl_00009VME7DD6Xm0axa2BU9",
            "iata_code": "QR",
            "conditions_of_carriage_url": "https://www.qatarairways.com/en-gb/legal/conditions-of-carriage.html"
        },
        "marketing_carrier_flight_number": "702",
        "marketing_carrier": {
            "name": "Qatar Airways",
            "logo_symbol_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/QR.svg",
            "logo_lockup_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-lockup/QR.svg",
            "id": "arl_00009VME7DD6Xm0axa2BU9",
            "iata_code": "QR",
            "conditions_of_carriage_url": "https://www.qatarairways.com/en-gb/legal/conditions-of-carriage.html"
        },
        "id": "seg_0000Ab9IpwldG9RRNhmx6b",
        "duration": "PT12H40M",
        "distance": null,
        "destination_terminal": null,
        "destination": {
            "type": "airport",
            "time_zone": "Asia/Qatar",
            "name": "Hamad International Airport",
            "longitude": 51.615118,
            "latitude": 25.260642,
            "id": "arp_doh_qa",
            "icao_code": "OTHH",
            "iata_country_code": "QA",
            "iata_code": "DOH",
            "iata_city_code": "DOH",
            "city_name": "Accra",
            "city": null,
            "airports": null
        },
        "departing_at": "2023-10-26T20:05:00",
        "arriving_at": "2023-10-27T15:45:00",
        "aircraft": {
            "name": "Boeing 777-300ER",
            "id": "arc_00009VMF8AhXSSRnQDI6HH",
            "iata_code": "77W"
        }
    }
]

module.exports = {
    segs
}